import { call, put, take, cancelled, cancel, fork } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import firebase from '../config/firebase'
import AppInboxActions, { AppInboxTypes } from '../reducers/appInboxReducer'

const observer = ref => {
    const listener = eventChannel(emit => {
      const subscriber = ref.onSnapshot(querySnapshot => {
        const inboxes = {}

        querySnapshot.forEach(doc => {
          inboxes[doc.id] = { ...doc.data(), id: doc.id }
        })
  
        emit(inboxes)
      }, err => {
        emit(new Error(err))
      })
  
      return () => subscriber
    })
    return listener
  }

export function* subscribeInboxes() {
  const inboxesRef = firebase.firestore().collection('app_inboxes')
  const channel = yield call(observer, inboxesRef)

  try {
    while(true) {
      const inboxes = yield take(channel)
      yield put(AppInboxActions.setAppInboxes(inboxes))
    }
  } catch (err) {
    yield put(AppInboxActions.setAppInboxesLoading(false))
  } finally {
    if (yield cancelled()) {
      channel.close()
    }
  }
}

export function* syncAppInboxes() {
  const appInboxesTask = yield fork(subscribeInboxes)

  yield take(AppInboxTypes.UN_SYNC_APP_INBOXES)
  yield cancel(appInboxesTask)
}

export function* deleteAppInbox({ appInboxId }) {
  const collectionRef = firebase.firestore().collection('app_inboxes').doc(appInboxId)
  const imageRef = firebase.storage().ref().child(`app_inboxes/${appInboxId}/image`)

  try {
    yield fork([collectionRef, collectionRef.delete])
    yield fork([imageRef, imageRef.delete])
  } catch (err) {
    alert(err)
  }
}




// WEBPACK FOOTER //
// ./src/sagas/appInboxSaga.js